import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getRoles } from "../../redux/actions/Roles";
import RolesFilter from "./RolesFilter";

class Roles extends React.Component {
  state = {
    name: ""
  };

  componentWillMount() {
    this.props.getRoles();
  }

  getFilteredRoles() {
    return this.props.roles.filter(role =>
      role.name.toLowerCase().includes(this.state.name.toLowerCase())
    );
  }

  render() {
    return (
      <div>
        <h1>Roles</h1>
        <RolesFilter
          onChange={e => {
            this.setState({
              [e.target.name]: e.target.value
            });
          }}
        />
        <table className="table table-sm table-responsive-md">
          <thead>
            <tr>
              <th>Role</th>
              <th># of permissions</th>
            </tr>
          </thead>
          <tbody>
            {this.getFilteredRoles().map((role, key) => (
              <tr key={key}>
                <td>
                  <Link to={"/role/" + role.id}>{role.name}</Link>
                </td>
                <td>{role.permissions.length}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

const mapStateToProps = ({ roles }) => ({ roles });

const mapDispatchToProps = dispatch => {
  return {
    getRoles: () => {
      return dispatch(getRoles());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Roles);



// WEBPACK FOOTER //
// ./src/containers/RolesPage/RolesPage.js